import { combineReducers } from '@reduxjs/toolkit';

import authentication from '../_slices/authentication.slice';
import { registration } from './registration.reducer';
import { users } from './users.reducer';
import { alert } from './alert.reducer';
import { vacanciesForm } from './vacanciesform.reducer';

import jobsForm from '../_slices/jobs.slice';
import businessProfileReducers from '../_slices/business-profile.slice';

const rootReducer = combineReducers({
  authentication,
  registration,
  users,
  alert,
  vacanciesForm,
  jobsForm,
  businessProfileReducers,
});

export default rootReducer;
